import { EntityNames } from "../../../../../enums/EntityNames";
import { httpGet } from "../../../../../modules/Backend";
import AdobeComboBox from "../../../../AdobeAriaLib/AdobeComboBox";
import { IOption } from "../../../../AdobeAriaLib/AdobeSelect";
import { useEffect, useState } from "react";
import { Change } from "../Form";

interface IFormAccountPrefix {
    isCreate: boolean,
    values: Record<string, any>,
    parentValues: Record<string, any> | undefined,
    onChangeBatched: Function,
}

export default function FormAccountPrefix({ isCreate, values, parentValues, onChangeBatched }: IFormAccountPrefix) {
    const [optionsMap, setOptionsMap] = useState<Map<string, IOption[]>>(new Map());
    const [loading, setLoading] = useState(false);

    async function handleAccountChange(value: string) {
        if (value) {
            const changes: Change[] = [
                { value: null, elementName: "prefix" },
                { value: value, elementName: "accountId" },
            ]
            onChangeBatched(changes);
            setOptions(EntityNames.prefixes, []);
            await getPrefixes(value);
        }
    }

    async function getPrefixes(accountId: string) {
        if (accountId) {
            const prefixParams = new URLSearchParams();
            prefixParams.append("AccountId", accountId);
            await getData(EntityNames.prefixes, prefixParams);
        }
    }

    function handlePrefixChange(value: string) {
        const changes: Change[] = [
            { value: value, elementName: "prefix" },
        ]
        onChangeBatched(changes);
    }

    function isDisabled() {
        return loading;
    }

    async function getData(entityName: string, params?: URLSearchParams) {
        try {
            setLoading(true)
            const paramsToAdd = params ? params.toString() : ''
            const result = await httpGet(`api/${entityName}/filterData?${paramsToAdd}`);
            if (result.data) {
                const options = result.data[entityName];
                setOptions(entityName, options);
            }
        }
        catch (err) {
        }
        setLoading(false)
    }

    function setOptions(entityName: string, options: IOption[]) {
        setOptionsMap((prevMap) => {
            const updatedMap = new Map(prevMap);
            updatedMap.set(entityName, [...options]);
            return updatedMap;
        });
    }

    function resolveAccountId() {
        if ('accountId' in values) {
            return values!['accountId'];
        }
        return isCreate ? parentValues!['belongsToId'] : values!['accountId'];
    }

    useEffect(() => {
        async function init() {
            await getData(EntityNames.accounts);
            const initialAccountId = resolveAccountId(); 
            await getPrefixes(initialAccountId);

            const changes: Change[] = [
                { value: initialAccountId, elementName: "accountId" }
            ]
            onChangeBatched(changes);
        }
        init()
    }, [])

    return (
        <div className="">
            {parentValues?.isChargedFor === false &&
                <div className="margin__bottom--s">
                    <AdobeComboBox
                        value={resolveAccountId()}
                        label={`Account (required)`}
                        labelVisible={true}
                        required={true}
                        options={optionsMap.get(EntityNames.accounts)}
                        onChangeSelect={handleAccountChange}
                        disabled={isDisabled()}
                        displayRequiredRule={() => false}
                        selectionMode="single" />
                </div>
            }
            <AdobeComboBox
                value={values?.prefix}
                label={'Prefix'}
                labelVisible={true}
                options={optionsMap.get(EntityNames.prefixes)}
                onChangeSelect={handlePrefixChange}
                disabled={isDisabled()}
                displayRequiredRule={() => false}
                selectionMode="single" />
        </div>
    )
}